/* Soft99 Danmark — tema-JS: hero-slider, karruselpile og mobilmenu. */
(function () {
  'use strict';

  /* ---------- Hero-slider ---------- */
  function initHero(root) {
    if (root.dataset.s99Init === 'true') return;
    root.dataset.s99Init = 'true';

    var slidesEl = root.querySelector('[data-s99-slides]');
    if (!slidesEl) return;

    var count = slidesEl.children.length;
    var dotsEl = root.querySelector('[data-s99-dots]');
    var index = 0;
    var timer = null;
    var interval = parseInt(root.dataset.s99Interval, 10) || 6000;

    if (count < 2) {
      if (dotsEl) dotsEl.style.display = 'none';
      root.querySelectorAll('.s99-hero__arrow').forEach(function (b) {
        b.style.display = 'none';
      });
      return;
    }

    if (dotsEl) {
      dotsEl.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 's99-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.dataset.index = i;
        dotsEl.appendChild(dot);
      }
      dotsEl.addEventListener('click', function (e) {
        var b = e.target.closest('.s99-dot');
        if (b) goTo(parseInt(b.dataset.index, 10));
      });
    }

    function goTo(i) {
      index = (i + count) % count;
      slidesEl.style.transform = 'translateX(-' + index * 100 + '%)';
      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.children, function (d, n) {
          d.classList.toggle('is-active', n === index);
        });
      }
    }

    root.querySelectorAll('[data-s99-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(index + parseInt(btn.dataset.s99Step, 10));
        stop();
      });
    });

    function start() {
      if (interval > 0) timer = setInterval(function () { goTo(index + 1); }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    root.addEventListener('pointerdown', stop);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () {
      if (!timer) start();
    });

    start();
  }

  /* ---------- Karruselpile ---------- */
  function initCarousel(root) {
    if (root.dataset.s99Init === 'true') return;
    root.dataset.s99Init = 'true';

    var track = root.querySelector('[data-s99-track]');
    if (!track) return;

    root.querySelectorAll('[data-s99-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.dataset.s99Scroll, 10);
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Mobilmenu ---------- */
  function initMobileNav(root) {
    if (root.dataset.s99NavInit === 'true') return;
    root.dataset.s99NavInit = 'true';

    var panel = root.querySelector('[data-s99-mobile]');
    var overlay = root.querySelector('[data-s99-overlay]');
    if (!panel) return;

    function open() {
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-s99-nav-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    root.querySelectorAll('[data-s99-nav-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Produktgalleri ---------- */
  function initGallery(root) {
    if (root.dataset.s99Init === 'true') return;
    root.dataset.s99Init = 'true';

    var thumbs = root.querySelectorAll('[data-s99-thumb]');
    var photos = root.querySelectorAll('[data-s99-photo]');
    if (!thumbs.length || !photos.length) return;

    function show(i) {
      photos.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.s99Photo === String(i));
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.s99Thumb === String(i));
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.s99Thumb); });
      t.addEventListener('mouseenter', function () { show(t.dataset.s99Thumb); });
    });
  }

  /* ---------- Faner ---------- */
  function initTabs(root) {
    if (root.dataset.s99Init === 'true') return;
    root.dataset.s99Init = 'true';

    var tabs = root.querySelectorAll('[data-s99-tab]');
    var panels = root.querySelectorAll('[data-s99-panel]');
    var accs = root.querySelectorAll('[data-s99-acc]');

    function vis(i) {
      tabs.forEach(function (x) { x.classList.toggle('is-active', x.dataset.s99Tab === i); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.s99Panel === i); });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { vis(t.dataset.s99Tab); });
    });

    /* Mobil: samme paneler foldes ud og ind i stedet for at skifte faneblad */
    accs.forEach(function (b) {
      b.setAttribute('aria-expanded', b.classList.contains('is-open') ? 'true' : 'false');
      b.addEventListener('click', function () {
        var luk = b.classList.contains('is-open');
        accs.forEach(function (x) {
          x.classList.remove('is-open');
          x.setAttribute('aria-expanded', 'false');
        });
        if (!luk) {
          b.classList.add('is-open');
          b.setAttribute('aria-expanded', 'true');
          vis(b.dataset.s99Acc);
        }
      });
    });
  }

  /* ---------- Antal-vælger ---------- */
  function initQty(root) {
    if (root.dataset.s99Init === 'true') return;
    root.dataset.s99Init = 'true';

    var input = root.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;

    root.querySelectorAll('[data-s99-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(input.value, 10);
        if (isNaN(n)) n = min;
        n += parseInt(b.dataset.s99QtyStep, 10);
        if (n < min) n = min;
        input.value = n;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Variantskift på produktsiden ---------- */
  function initVariants(root) {
    if (root.dataset.s99Init === 'true') return;
    root.dataset.s99Init = 'true';

    var select = root.querySelector('[data-s99-variant-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Sortering på kollektionssiden ---------- */
  function initSort(select) {
    if (select.dataset.s99Init === 'true') return;
    select.dataset.s99Init = 'true';

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }


  /* ---------- Kurv-skuffe ----------
     Erstatter den almindelige POST til /cart/add, som sender kunden væk fra
     produktsiden. Bruger Shopifys AJAX-kurv, så kunden bliver hvor han er. */
  function initCart() {
    var drawer = document.querySelector('[data-s99-cart-drawer]');
    if (!drawer || drawer.dataset.s99Init === 'true') return;
    drawer.dataset.s99Init = 'true';

    var overlay = document.querySelector('[data-s99-cart-overlay]');
    var items = drawer.querySelector('[data-s99-cart-items]');
    var tom = drawer.querySelector('[data-s99-cart-empty]');
    var foot = drawer.querySelector('[data-s99-cart-foot]');
    var total = drawer.querySelector('[data-s99-cart-total]');
    var antal = drawer.querySelector('[data-s99-cart-count]');
    var fragt = drawer.querySelector('[data-s99-cart-shipping]');
    var sidstFokus = null;

    function kr(oere) {
      return (oere / 100).toLocaleString('da-DK', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }) + ' kr';
    }

    function aaben() {
      sidstFokus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var luk = drawer.querySelector('[data-s99-cart-close]');
      if (luk) luk.focus();
    }

    function luk() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (sidstFokus && sidstFokus.focus) sidstFokus.focus();
    }

    function badge(n) {
      document.querySelectorAll('[data-s99-cart-badge]').forEach(function (b) {
        b.textContent = n;
        if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
      });
    }

    function visFragt(sum) {
      if (!fragt) return;
      var graense = parseInt(fragt.dataset.s99Threshold, 10) || 0;
      if (!graense || sum === 0) { fragt.innerHTML = ''; return; }
      if (sum >= graense) {
        fragt.innerHTML = '<p class="s99-fragt__ok">Du har fri fragt</p>';
      } else {
        var pct = Math.round((sum / graense) * 100);
        fragt.innerHTML =
          '<p>Du mangler <strong>' + kr(graense - sum) + '</strong> til fri fragt</p>' +
          '<div class="s99-fragt__bar"><i style="width:' + pct + '%"></i></div>';
      }
    }

    function tegn(cart) {
      badge(cart.item_count);
      if (antal) antal.textContent = '(' + cart.item_count + ')';
      if (total) total.textContent = kr(cart.total_price);
      visFragt(cart.total_price);

      if (!cart.items.length) {
        items.innerHTML = '';
        if (tom) tom.removeAttribute('hidden');
        if (foot) foot.setAttribute('hidden', '');
        return;
      }
      if (tom) tom.setAttribute('hidden', '');
      if (foot) foot.removeAttribute('hidden');

      // Er det de samme linjer i samme rækkefølge, opdateres tallene på
      // stedet. At erstatte innerHTML ville rive billeder og fokus ned og
      // give et synligt glimt ved hver antalsændring.
      var eksisterende = Array.prototype.map.call(
        items.querySelectorAll('[data-key]'), function (el) { return el.dataset.key; });
      var samme = eksisterende.length === cart.items.length &&
        cart.items.every(function (i, n) { return eksisterende[n] === i.key; });

      if (samme) {
        cart.items.forEach(function (i, n) {
          var row = items.querySelector('[data-key="' + i.key + '"]');
          if (!row) return;
          var felt = row.querySelector('[data-s99-line-qty]');
          if (felt && document.activeElement !== felt) felt.value = i.quantity;
          var pris = row.querySelector('.s99-cartrow__pris');
          if (pris) {
            pris.innerHTML = (i.original_line_price > i.final_line_price
              ? '<s>' + kr(i.original_line_price) + '</s> ' : '') + kr(i.final_line_price);
          }
          row.classList.remove('is-pending');
        });
        return;
      }

      items.innerHTML = cart.items.map(function (i, n) {
        var billede = i.image
          ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
            '" alt="" width="80" height="80" loading="lazy">'
          : '';
        var variant = (i.variant_title && i.variant_title !== 'Default Title')
          ? '<span class="s99-cartrow__variant">' + i.variant_title + '</span>' : '';
        var foer = (i.original_line_price > i.final_line_price)
          ? '<s>' + kr(i.original_line_price) + '</s> ' : '';
        return '' +
          '<li class="s99-cartrow" data-line="' + (n + 1) + '" data-key="' + i.key + '">' +
            '<a class="s99-cartrow__img" href="' + i.url + '">' + billede + '</a>' +
            '<div class="s99-cartrow__midt">' +
              '<a class="s99-cartrow__navn" href="' + i.url + '">' + i.product_title + '</a>' +
              variant +
              '<div class="s99-qty s99-cartrow__qty">' +
                '<button type="button" class="s99-qty__btn" data-s99-line-step="-1" aria-label="Færre">&minus;</button>' +
                '<input type="number" value="' + i.quantity + '" min="0" inputmode="numeric" aria-label="Antal" data-s99-line-qty>' +
                '<button type="button" class="s99-qty__btn" data-s99-line-step="1" aria-label="Flere">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="s99-cartrow__hoejre">' +
              '<span class="s99-cartrow__pris">' + foer + kr(i.final_line_price) + '</span>' +
              '<button type="button" class="s99-cartrow__fjern" data-s99-line-remove>Fjern</button>' +
            '</div>' +
          '</li>';
      }).join('');
    }

    function hent() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(tegn);
    }

    /* Klik på + og - må ikke låse knappen, mens kaldet er undervejs — så
       forsvinder de klik, kunden når at lave i mellemtiden. I stedet
       opdateres feltet straks, og først når der er ro, sendes det endelige
       antal til serveren. */
    var vent = {};

    function skift(line, quantity, straks) {
      var row = items.querySelector('[data-line="' + line + '"]');
      if (row) {
        row.classList.add('is-pending');
        var felt = row.querySelector('[data-s99-line-qty]');
        if (felt && quantity > 0) felt.value = quantity;
      }
      if (vent[line]) clearTimeout(vent[line]);
      if (straks) return send(line, quantity);
      vent[line] = setTimeout(function () { send(line, quantity); }, 350);
    }

    function send(line, quantity) {
      delete vent[line];
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(tegn)
        .catch(function () { window.location.href = '/cart'; });
    }

    /* Åbn / luk */
    document.querySelectorAll('[data-s99-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        aaben();
        hent();
      });
    });
    drawer.querySelectorAll('[data-s99-cart-close]').forEach(function (b) {
      b.addEventListener('click', luk);
    });
    if (overlay) overlay.addEventListener('click', luk);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) luk();
    });

    /* Linjeændringer */
    items.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]');
      if (!row) return;
      var line = parseInt(row.dataset.line, 10);
      if (e.target.closest('[data-s99-line-remove]')) return skift(line, 0, true);
      var step = e.target.closest('[data-s99-line-step]');
      if (step) {
        var felt = row.querySelector('[data-s99-line-qty]');
        var n = parseInt(felt.value, 10) + parseInt(step.dataset.s99LineStep, 10);
        return skift(line, Math.max(0, n));
      }
    });
    items.addEventListener('change', function (e) {
      var felt = e.target.closest('[data-s99-line-qty]');
      if (!felt) return;
      var row = felt.closest('[data-line]');
      skift(parseInt(row.dataset.line, 10), Math.max(0, parseInt(felt.value, 10) || 0), true);
    });

    /* Læg i kurv uden at forlade siden */
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var knap = form.querySelector('[name="add"]');
        if (knap) { knap.disabled = true; knap.dataset.s99Label = knap.textContent; knap.textContent = 'Lægger i kurv…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form),
                                headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            return hent();
          })
          .then(aaben)
          .catch(function () { form.submit(); })
          .finally(function () {
            if (knap) { knap.disabled = false; knap.textContent = knap.dataset.s99Label || 'Læg i kurv'; }
          });
      });
    });
  }

  function initAll(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-s99-hero]').forEach(initHero);
    ctx.querySelectorAll('[data-s99-carousel]').forEach(initCarousel);
    ctx.querySelectorAll('[data-s99-header]').forEach(initMobileNav);
    ctx.querySelectorAll('[data-s99-gallery]').forEach(initGallery);
    ctx.querySelectorAll('[data-s99-tabs]').forEach(initTabs);
    ctx.querySelectorAll('[data-s99-qty]').forEach(initQty);
    ctx.querySelectorAll('[data-s99-pdp]').forEach(initVariants);
    ctx.querySelectorAll('[data-s99-sort]').forEach(initSort);
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: genstart når en sektion indlæses på ny */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
